import DepositRefundApi, {
  DepositRefundFile,
  DepositRefundReceiptRow,
} from "../../api/deposit-refund";

/** ตัด timestamp ที่ backend เติมหน้าชื่อไฟล์ออก ('1725690000000-ใบเสร็จ.pdf' -> 'ใบเสร็จ.pdf') */
export const displayFileName = (fileName?: string) =>
  String(fileName || "").replace(/^\d{10,}-/, "") || "-";

/**
 * สั่งเบราว์เซอร์เซฟ blob เป็นไฟล์ — ใช้ร่วมกันทั้งไฟล์แนบและใบเสร็จ
 * ไม่ใช้ file-saver เพราะแค่ 6 บรรทัดนี้ก็พอ และไม่ต้องเพิ่ม dependency ในหน้าเดียว
 */
export const saveBlobAsFile = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  // Firefox ต้องให้ element อยู่ใน DOM ก่อน click ไม่งั้นไม่เริ่มดาวน์โหลด
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // revoke ช้าหน่อย กันบาง browser ที่ยังอ่าน blob ไม่เสร็จตอน click คืนค่า
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

/**
 * ดาวน์โหลดไฟล์แนบผ่าน API ที่มี token — เปิด URL ตรงไม่ได้เพราะ endpoint อยู่ใต้ JWT guard
 * โยน error ต่อให้ผู้เรียกจัดการข้อความ (404 ของ backend ตอบ body ว่าง จึงต้อง fallback ข้อความเอง)
 */
export const downloadDepositRefundFile = async (file: DepositRefundFile) => {
  const res = await DepositRefundApi.downloadFile(file.download_url);
  // ใช้ชื่อจาก list ตรงๆ ไม่ต้อง parse Content-disposition ที่ผ่าน encodeURI มา
  saveBlobAsFile(res.data, displayFileName(file.file_name));
};

/**
 * ดาวน์โหลดใบเสร็จ (PDF) จากตารางใบเสร็จ
 *
 * download_url ที่ API คืนมาเป็น relative path ('invoice/11266/receipt') ต่อกับ baseURL
 * ของ axios ได้เลย จึงยิงด้วย downloadFile ตัวเดิมได้ ไม่ต้องแยก if ตาม source
 * เพราะ backend ประกอบ path ของแต่ละที่มาไว้ให้แล้ว
 */
export const downloadDepositRefundReceipt = async (row: DepositRefundReceiptRow) => {
  const res = await DepositRefundApi.downloadFile(row.download_url);
  // DEPOSIT ไม่มีเลขใบเสร็จ (receipt_no = null) จึงตั้งชื่อไฟล์ด้วยเลขที่เอกสารเป็นหลัก
  saveBlobAsFile(res.data, `ใบเสร็จ_${row.document_no || row.refId}.pdf`);
};

/**
 * เปิดดูไฟล์แนบในแท็บใหม่ (backend ส่ง Content-disposition: attachment แต่ blob ที่ front ถือทำอะไรก็ได้)
 *
 * ต้องรับ tab ที่ผู้เรียก window.open('', '_blank') ไว้แล้วตอน onClick — เปิดหลัง await
 * จะหลุด user gesture แล้วโดน popup blocker
 */
export const openDepositRefundFile = async (
  file: DepositRefundFile,
  tab: Window | null
) => {
  const res = await DepositRefundApi.downloadFile(file.download_url);

  const url = URL.createObjectURL(res.data);
  if (tab) tab.location.href = url;
  // ให้เวลาแท็บโหลดไฟล์ให้เสร็จก่อน revoke — เร็วกว่านี้ PDF ขนาดใหญ่จะเปิดไม่ขึ้น
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
